/**
 * @generated SignedSource<<2c28910814900ea4cf5e3c439a5a8522>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventTicketingTierItem_eventTicketingTier$data = {
  readonly currency: string;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly includeTax: boolean;
  readonly name: string;
  readonly price: number;
  readonly taxName: string | null | undefined;
  readonly taxPercentage: number | null | undefined;
  readonly " $fragmentType": "EventTicketingTierItem_eventTicketingTier";
};
export type EventTicketingTierItem_eventTicketingTier$key = {
  readonly " $data"?: EventTicketingTierItem_eventTicketingTier$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventTicketingTierItem_eventTicketingTier">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventTicketingTierItem_eventTicketingTier",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeTax",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxPercentage",
      "storageKey": null
    }
  ],
  "type": "EventTicketingTier",
  "abstractKey": null
};

(node as any).hash = "63b83c76f188b479102c8bf79191b987";

export default node;
